import React from 'react';
import { Shirt, Droplets, Wind, Scissors, Sparkles, Heart, BedDouble, Clock } from 'lucide-react';

export default function Services() {
  const services = [
    {
      icon: <Shirt className="w-6 h-6" />,
      title: "Dry Cleaning",
      description: "Expert care for your suits, dresses, and delicate garments using premium solvents."
    },
    {
      icon: <Droplets className="w-6 h-6" />,
      title: "Wash & Fold",
      description: "Everyday laundry washed, dried, and neatly folded. Ready for your drawer."
    },
    {
      icon: <Wind className="w-6 h-6" />,
      title: "Pressing",
      description: "Professional steam pressing and finishing for a crisp, sharp appearance."
    },
    {
      icon: <Scissors className="w-6 h-6" />,
      title: "Alterations",
      description: "Expert tailoring and repairs to ensure the perfect fit for your clothes."
    },
    {
      icon: <Sparkles className="w-6 h-6" />,
      title: "Stain Removal",
      description: "Advanced treatment techniques to safely remove stubborn stains and spots."
    },
    {
      icon: <Heart className="w-6 h-6" />,
      title: "Wedding Gowns",
      description: "Specialized cleaning and preservation for your most cherished memories."
    },
    {
      icon: <BedDouble className="w-6 h-6" />,
      title: "Household",
      description: "Deep cleaning for comforters, curtains, linens, and other home textiles."
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: "Fast Service",
      description: "Reliable turnaround times with express options available for urgent needs."
    }
  ];

  return (
    <section id="services" className="py-20 bg-surface">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
            style={{
              color: "#6b7d5d"
            }}>Our Services</h2>
          <p className="text-gray-600">
            From everyday laundry to delicate couture, we provide comprehensive garment care solutions tailored to your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 group"
            >
              <div className="w-12 h-12 bg-brand/5 rounded-xl flex items-center justify-center mb-4 text-brand group-hover:bg-brand group-hover:text-white transition-colors duration-300">
                {service.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
